"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var VAlert_vue_1 = __importDefault(require("../scraps/VAlert.vue"));
var VModal_vue_1 = __importDefault(require("../scraps/VModal.vue"));
var VButton_vue_1 = __importDefault(require("../scraps/VButton.vue"));
var UserNameInput_vue_1 = __importDefault(require("../form/UserNameInput.vue"));
var EmailAddressInput_vue_1 = __importDefault(require("../form/EmailAddressInput.vue"));
var PasswordInput_vue_1 = __importDefault(require("../form/PasswordInput.vue"));
var RoleMultiselect_vue_1 = __importDefault(require("../form/RoleMultiselect.vue"));
var errors_1 = __importDefault(require("../../config/errors"));
var event_bus_1 = require("../../event-bus");
var DistrictMultiselect_vue_1 = __importDefault(require("../form/DistrictMultiselect.vue"));
var UnitMultiselect_vue_1 = __importDefault(require("../form/UnitMultiselect.vue"));
exports.default = vue_1.default.extend({
    name: "create-user-modal",
    components: {
        VAlert: VAlert_vue_1.default,
        VButton: VButton_vue_1.default,
        VModal: VModal_vue_1.default,
        UserNameInput: UserNameInput_vue_1.default,
        EmailAddressInput: EmailAddressInput_vue_1.default,
        PasswordInput: PasswordInput_vue_1.default,
        RoleMultiselect: RoleMultiselect_vue_1.default,
        DistrictMultiselect: DistrictMultiselect_vue_1.default,
        UnitMultiselect: UnitMultiselect_vue_1.default
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        roles: {
            type: Array,
            required: true
        },
        districts: {
            type: Array,
            required: true
        },
        units: {
            type: Array,
            required: true
        }
    },
    data: function () {
        return {
            name: "",
            email: "",
            password: "",
            currentRoles: [],
            currentDistricts: [],
            currentUnits: [],
            invalidUserName: false,
            invalidEmailAddress: false,
            invalidPassword: false,
            invalidRoles: false,
            invalidUnits: false,
            errors: errors_1.default
        };
    },
    watch: {
        show: function () {
            this.resetData();
            if (this.show) {
                event_bus_1.EventBus.$on(event_bus_1.events.role.select, this.updateCurrentRoles);
                event_bus_1.EventBus.$on(event_bus_1.events.district.select, this.updateCurrentDistricts);
                event_bus_1.EventBus.$on(event_bus_1.events.unit.select, this.updateCurrentUnits);
            }
        },
        roles: function () {
            this.currentRoles = [];
        },
        districts: function () {
            this.currentDistricts = [];
            this.currentUnits = [];
        },
        units: function () {
            this.currentUnits = [];
        }
    },
    created: function () {
        event_bus_1.EventBus.$on(event_bus_1.events.role.select, this.updateCurrentRoles);
        event_bus_1.EventBus.$on(event_bus_1.events.district.select, this.updateCurrentDistricts);
        event_bus_1.EventBus.$on(event_bus_1.events.unit.select, this.updateCurrentUnits);
    },
    beforeDestroy: function () {
        event_bus_1.EventBus.$off(event_bus_1.events.role.select, this.updateCurrentRoles);
        event_bus_1.EventBus.$off(event_bus_1.events.district.select, this.updateCurrentDistricts);
        event_bus_1.EventBus.$off(event_bus_1.events.unit.select, this.updateCurrentUnits);
    },
    methods: {
        updateCurrentRoles: function (roles) {
            this.currentRoles = roles;
        },
        updateCurrentDistricts: function (districts) {
            this.currentDistricts = districts;
            this.currentUnits = [];
        },
        updateCurrentUnits: function (units) {
            this.currentUnits = units;
        },
        resetData: function () {
            this.name = "";
            this.email = "";
            this.password = "";
            this.currentRoles = [];
            this.currentDistricts = [];
            this.currentUnits = [];
            this.invalidUserName = false;
            this.invalidEmailAddress = false;
            this.invalidPassword = false;
            this.invalidRoles = false;
            this.invalidUnits = false;
        },
        onKeyDown: function (keyCode) {
            if (keyCode === 13) {
                this.onCreateUser();
            }
        },
        onClose: function () {
            this.resetData();
            event_bus_1.EventBus.$off(event_bus_1.events.role.select, this.updateCurrentRoles);
            event_bus_1.EventBus.$off(event_bus_1.events.district.select, this.updateCurrentDistricts);
            event_bus_1.EventBus.$off(event_bus_1.events.unit.select, this.updateCurrentUnits);
            this.$emit("close");
        },
        inputsValid: function () {
            var _this = this;
            for (var _i = 0, _a = ["name", "email", "password"]; _i < _a.length; _i++) {
                var ref = _a[_i];
                if (!this.$refs[ref].isValid(true)) {
                    this.$refs[ref].appendValidationClass();
                    return false;
                }
            }
            this.invalidRoles = (this.currentRoles.length === 0);
            this.invalidUnits = !!this.currentUnits.find(function (unit) { return !_this.currentDistricts.find(function (district) { return district.id === unit.district_id; }); });
            return (this.currentRoles.length > 0);
        },
        onCreateUser: function () {
            if (!this.inputsValid()) {
                return;
            }
            this.$emit("createUser", {
                name: this.name,
                email: this.email,
                password: this.password,
                roles: this.currentRoles.map(function (role) { return role.name; }),
                districts: this.currentDistricts.map(function (district) { return district.id; }),
                units: this.currentUnits.map(function (unit) { return unit.id; })
            });
            this.onClose();
        }
    }
});
